import { Flex as RadixFlex } from '@radix-ui/themes'
import { forwardRef } from 'react'
import type { ComponentPropsWithoutRef } from 'react'

type FlexProps = ComponentPropsWithoutRef<typeof RadixFlex>

export const Flex = forwardRef<HTMLDivElement, FlexProps>(
  ({ className = '', ...props }, ref) => {
    return <RadixFlex className={className} ref={ref} {...props} />
  }
)

Flex.displayName = 'Flex'
